import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/pro-solid-svg-icons/faTimes';

import React, { useContext, useCallback } from 'react';
import PropTypes from 'prop-types';
import { AutomationRulesContext, doesUserHaveAccessToEveryActiveRuleAction } from '../../../../context';
import { Button } from 'ui-components/components/button';
import style from '../style.module.less';

const ActionRemover = ({ orderRuleActionId }) => {
  const { selectedRule, setSelectedRule, setHasAccess, ruleTypesHashMap } = useContext(AutomationRulesContext);

  const onRemoveAction = useCallback(() => {
    const updatedActions = selectedRule.orderRuleActions.reduce((acc, action) => {
      // Skip null/undefined actions
      if (!action) return acc;
      const isTargetAction = action.orderRuleActionId?.toString() === orderRuleActionId?.toString();

      // Actions with undefined actionTypeId (new actions) targeted for deletion should be removed instead of marked as deleted
      if (isTargetAction && !action.actionTypeId) {
        return acc;
      }

      // If the action is targeted for removal, mark it as deleted
      if (isTargetAction) {
        acc.push({ ...action, isDeleted: true });
      } else {
        acc.push(action);
      }

      return acc;
    }, []);

    const areAllActionsEnabled = doesUserHaveAccessToEveryActiveRuleAction(updatedActions, ruleTypesHashMap);

    // Update the selected rule with modified actions
    setSelectedRule({
      ...selectedRule,
      orderRuleActions: updatedActions,
    });

    // Update access state based on whether there are any inaccessible actions
    setHasAccess(areAllActionsEnabled);
  }, [orderRuleActionId, selectedRule, ruleTypesHashMap, setSelectedRule, setHasAccess]);
  return (
    <div className={style.remover}>
      <Button className={style['action-remover']} onClick={onRemoveAction} theme='unstyled'>
        <FontAwesomeIcon className={style.icon} icon={faTimes} />
      </Button>
    </div>
  );
};

ActionRemover.propTypes = {
  orderRuleActionId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
};

export default ActionRemover;
